module.exports = __webpack_public_path__ + "img/traveller_active.b2b14e0a.svg";